// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__SupUX","Content":"Layout_Content__p3a1y"};